<script lang="ts">
    import { onMount } from 'svelte';
    import { api } from '../lib/api';
    import { toast } from '../lib/stores/toast.svelte';
    import type { Subscription } from '../lib/types';
    import { formatRelative } from '../lib/format';

    let items = $state<Subscription[]>([]);
    let loading = $state(true);

    async function load() {
        loading = true;
        try { items = await api<Subscription[]>('/api/subscriptions'); }
        finally { loading = false; }
    }
    onMount(load);

    async function ping(id: string) {
        try { await api(`/api/subscriptions/${id}/ping`, { method: 'POST' }); toast.info('Ping queued'); setTimeout(load, 1500); }
        catch (err: any) { toast.error(err.message); }
    }

    async function del(id: string) {
        if (!confirm('Remove this subscription? The app will need to handshake again.')) return;
        try { await api(`/api/subscriptions/${id}`, { method: 'DELETE' }); load(); }
        catch (err: any) { toast.error(err.message); }
    }
</script>

<div class="page-header">
    <h1>Webhook Subscriptions</h1>
    <button onclick={load}>Refresh</button>
</div>

{#if loading}
    <p class="muted">Loading...</p>
{:else}
    <div class="card">
        <table>
            <thead>
            <tr>
                <th>App</th><th>Environment</th><th>Callback</th><th>Status</th>
                <th>Last Ping</th><th>Latency</th><th>Retries</th><th></th>
            </tr>
            </thead>
            <tbody>
            {#each items as s}
                <tr>
                    <td><strong>{s.consumer.name}</strong></td>
                    <td><span style="color: {s.environment.themeColor};">{s.environment.name}</span></td>
                    <td class="mono small">{s.callbackUrl}</td>
                    <td>
              <span class="badge {s.lastPingStatus === 'SUCCESS' ? 'success' : s.lastPingStatus === 'FAILED' ? 'danger' : 'warning'}">
                {s.lastPingStatus}
              </span>
                    </td>
                    <td>{formatRelative(s.lastPingAt)}</td>
                    <td>{s.lastLatencyMs ? `${s.lastLatencyMs}ms` : '—'}</td>
                    <td>{s.retryCount}</td>
                    <td class="actions">
                        <button class="ghost" onclick={() => ping(s.id)}>Ping</button>
                        <button class="ghost" onclick={() => del(s.id)}>🗑</button>
                    </td>
                </tr>
            {:else}
                <tr><td colspan="8" class="muted" style="text-align:center;padding:20px;">No subscriptions yet.</td></tr>
            {/each}
            </tbody>
        </table>
    </div>
{/if}

<style>
    .page-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
    table { width: 100%; border-collapse: collapse; }
    th, td { padding: 10px 12px; text-align: left; border-bottom: 1px solid var(--border); font-size: 13px; }
    th { font-size: 11px; text-transform: uppercase; color: var(--text-2); }
    .small { font-size: 12px; max-width: 280px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .actions { text-align: right; }
</style>